/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Logout/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Logout({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Logout",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2
  
}) {
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let fill2OrdtColorsBlack = fill2 ?? dtColorsBlack
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Logout.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-ZtGo36': alignSelf,'--mt-2-ZtGo36': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZtGo36': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZtGo36': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZtGo36': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZtGo36': opacity,'--w-10-ZtGo36': typeof width === 'number' ? `${width}px` : width,'--h-11-ZtGo36': typeof height === 'number' ? `${height}px` : height,'--f-12-ZtGo36': fill,'--a-7-ZtGo36': isAnimated ? animation : "none",'--sd-8-ZtGo36': isAnimated ? strokeDashoffset : 0,'--sd-9-ZtGo36': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Logout.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.143 3.429C2.959 3.429 2 4.389 2 5.572v12.857c0 1.183.96 2.143 2.143 2.143H17c1.183 0 2.143-.96 2.143-2.143v-.923a2.856 2.856 0 01-3.906-2.292h-5.023a3.214 3.214 0 010-6.428h5.023a2.857 2.857 0 013.906-2.292v-.922c0-1.184-.96-2.143-2.143-2.143H4.143zm14.686 4.956l.314.314 2.543 2.544a1.071 1.071 0 010 1.515l-2.857 2.857A1.071 1.071 0 0117 14.857V13.43h-6.786a1.429 1.429 0 110-2.857H17V9.143a1.075 1.075 0 01.661-.99c.4-.166.862-.074 1.168.232z"
 style={{'--f-12-ZtGo36': fill2OrdtColorsBlack}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}